import React, { useMemo, useState } from 'react'
import Card from 'react-bootstrap/Card';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import FormCustom from '../../Components/Form/FormCustom';
import Input from '../../Components/Form/Input';
import Button from 'react-bootstrap/Button'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';

const ReporteProductoClave = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [excel, setExcel] = useState(null)
    const [data, setData] = useState({
        p_key_product: ''
    })

    const onSubmit = _ => {
        if (!data.p_key_product) {
            Helpers.toast.construct({ toast, response: 'warning', message: 'Ingrese la clave de producto' })
            return
        }

        setIsProccesing(true)
        setRows([])
        setExcel(null)
        Controllers.report.report_sale_by_product_key(data)
            .then(res => {
                if (res.response !== 'success') {
                    Helpers.toast.construct({ ...res, toast })
                    return
                }
                setRows(res.data.rows)
                setExcel(res.data.excel)
            })
            .catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => setIsProccesing(false))
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[[
            { name: 'id_document', text: 'ID Venta', align: 'center' },
            { name: 'date_doc', text: 'Fecha', align: 'center' },
            { name: 'name_branch_office', text: 'Sucursal' },
            { name: 'qty_pack', text: 'Cantidad', align: 'center' },
            { name: 'price', text: 'Precio', align: 'right' },
            { name: 'key_product', text: 'Clave', align: 'center' },
            { name: 'name_product', text: 'Producto' },
        ]]}
        rows={rows}
        isProcessing={isProcessing}
        pageLength={50}
        columnOrder="id_document"
        orderDirection="desc"
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Reporte por Clave de Producto</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false} onSubmit={onSubmit}>
                    <Input
                        classNameParent="col-12 col-md-6 mb-2"
                        icon="fa fa-barcode"
                        placeholder="Clave Producto (ej. ET9019)"
                        text="Clave Producto"
                        required
                        value={data.p_key_product}
                        onChange={e => setData({ ...data, p_key_product: e.currentTarget.value.trim() })}
                        append={[
                            <Button type="submit" size="sm">
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                    />
                </FormCustom>
                {excel?.file && <div className='mb-3'>
                    <a href={excel.file} download={excel.filename}>
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>
                            Descargar Excel
                        </Button>
                    </a>
                </div>}
                {dtRows}
            </Card.Body>
        </Card>
    </>
}

export default ReporteProductoClave


